import { Avatar } from 'antd'
import { Dropdown, OptionGroup } from 'pollination-react-io'
import React, { useEffect, useMemo } from 'react'

import {
  ApiOutlined,
  AppstoreAddOutlined,
  KeyOutlined,
  LogoutOutlined,
  NodeIndexOutlined,
  ProfileOutlined,
  ProjectOutlined,
  SettingOutlined,
  TeamOutlined,
  ThunderboltOutlined, UsergroupAddOutlined, UserOutlined
} from '@ant-design/icons'
import { useAccountInfo } from 'hooks/useAccountInfo'
import { ResourceType, useRoles } from 'hooks/useRoles'
import { useHistory } from 'react-router-dom'
import styles from './Header.module.css'
import { useAuth } from 'auth-context'

interface AccountOptionsProps {
  disabled: boolean
  logout: () => void
}

export const AccountOptions = ({
  disabled,
  logout
}: AccountOptionsProps): React.ReactElement<AccountOptionsProps> => {
  const history = useHistory()
  const { user } = useAuth()

    const items = useMemo(() => {
    const options = {
      account: {
        type: 'node',
        content: <h3>{`👋 ${user?.name ?? user?.username}!`}</h3>,
        id: `${user?.name ?? user?.username}-label`,
      },
      settings: {
        type: 'button',
        label: 'My Profile',
        id: 'profile',
        icon: <ProfileOutlined />,
        onSelect: () => history
          .push(`/${user?.username}?tab=settings`),
      },
      licensePools: {
        type: 'button',
        label: 'License Pools',
        id: 'license-pools',
        icon: <KeyOutlined />,
        onSelect: () => history
          .push(`/${user?.username}/licenses`),
      },
      cadPlugins: {
        type: 'button',
        label: 'Download CAD Plugins',
        id: 'cad-plugins',
        icon: <ApiOutlined />,
        onSelect: () => history
          .push('/cad-plugins'),
      },
      logout: {
        type: 'button',
        icon: <LogoutOutlined />,
        label: 'Logout',
        id: 'logout',
        onSelect: () => logout()
      }
    }
    return [
      {
        options: [
          options.account,
          options.settings,
          options.cadPlugins,
          options.licensePools
        ]
      },
      {
        options: [
          options.logout
        ]
      }
    ] as OptionGroup[]

  }, [user, logout, history])

  return (
    <Dropdown
      optionGroups={items ?? []}
      contentProps={{
        align: 'end',
        sideOffset: -8,
        style: {
          borderColor: 'var(--primary)',
          zIndex: 1000,
          lineHeight: '1.25rem',
        }
      }}
      disabled={disabled}
      trigger={
        <button className={styles['header-avatar-button']}>
          <Avatar src={user?.picture}
            size={'default'}
            shape='circle'
            className={styles['header-avatar-trigger']}
            style={{
              backgroundColor: 'rgba(0,0,0,0)',
              marginLeft: 2,
            }}
          />
        </button>
      }
    />)
}